import { appConfig } from '@/config/environment'

type FeedbackAssistantInitOptions = {
  token: string
  getUserToken?: () => string | null | undefined
  getAccessToken?: () => string | null | undefined
  getTenantId?: () => string | number | null | undefined
  routeMode?: 'history' | 'hash'
  ignorePaths?: Array<string | RegExp>
}

declare global {
  interface Window {
    TechforceFeedbackAssistant?: {
      init: (options: FeedbackAssistantInitOptions) => void
    }
  }
}

const feedbackAssistantToken = appConfig.feedbackAssistantToken

function getFeedbackUserToken(): string | null {
  try {
    const user = JSON.parse(window.localStorage.getItem('user') || '{}')
    return user.id != null ? String(user.id) : window.localStorage.getItem('userToken')
  } catch (error) {
    return window.localStorage.getItem('userToken')
  }
}

function getFeedbackTenantId(): string | number | null {
  try {
    const tenant = JSON.parse(window.localStorage.getItem('currentTenant') || '{}')
    return tenant.id ?? null
  } catch {
    return null
  }
}

function getFeedbackAccessToken(): string | null {
  return window.localStorage.getItem('token')
}

if (feedbackAssistantToken && window.TechforceFeedbackAssistant) {
  window.TechforceFeedbackAssistant.init({
    token: feedbackAssistantToken,
    getUserToken: getFeedbackUserToken,
    getAccessToken: getFeedbackAccessToken,
    getTenantId: getFeedbackTenantId,
    routeMode: 'history',
    ignorePaths: ['/login']
  })
}
